import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="DESPRE" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Aceasta este o clonă a jocului Wordle adaptată la limba română de prof. I.D. Nedelcu.
         Varianta originală, în limba engleză, se găsește 
        
        <a
          href="https://www.powerlanguage.co.uk/wordle/"
          className="underline font-bold"
        >
          aici
        </a>.
      </p>
    </BaseModal>
  )
}
